<template>
  <article class="geogebra">
    <ErrorMessage v-if="errorMessage">
      <p>{{ errorMessage }}</p>
    </ErrorMessage>
    <div class="geogebra-applet" ref="geogebraApplet" />
  </article>
</template>

<script>
import ErrorMessage from '@/components/ui/ErrorMessage'
import logger from '@/utils/logger'

/**
 * This file does exactly the same thing as Geogebra.vue,
 * but Geogebra messes up the cropping/scaling on the "real" Vue implementation for no apparent reason.
 * This file is meant to be used in the same way as Geogebra.vue, but utilises the Google Closure component
 * edulab.components.geometry.FileExecutor under the hood.
 *
 * @author Thomas Grinderslev <thg@lru.dk>
 */
export default {
  name: 'GeogebraLegacy',
  components: { ErrorMessage },
  props: {
    fileData: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      fileExecutor: null,
    }
  },
  computed: {
    errorMessage() {
      if (!this.fileData || !this.fileData.trim()) {
        return this.$t('media.geogebra.missing-data')
      }

      return null
    },
  },
  mounted() {
    try {
      this.fileExecutor = new edulab.components.geometry.FileExecutor(
        this.fileData
      )
      this.$nextTick(() => {
        this.fileExecutor.render(this.$refs.geogebraApplet)
      })
    } catch (err) {
      logger.error(err)
    }
  },
  beforeDestroy() {
    try {
      edulab.base.dispose(this.fileExecutor)
    } catch (err) {
      logger.error(err)
    }
  },
}
</script>

<style lang="scss" scoped>
.geogebra {
}
</style>
